import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { BuildSchedule } from '@portal-core/builds/models/build-schedule.model';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';

@CollectionStateSelectors({
  stateType: BuildsScheduleState
})
@State<BuildsScheduleState>({
  name: BuildsScheduleState.source,
})
@Service({ autoProvided: false })
export class BuildsScheduleState extends CollectionStateBase {
  static override source = 'BuildsSchedule';
  getSource(): string {
    return BuildsScheduleState.source;
  }
}

@Service()
export class BuildsScheduleDataService extends CollectionDataServiceBase<BuildSchedule> {
  protected readonly stateType = BuildsScheduleState;
}
